"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/namespace */
// eslint-disable-next-line import/no-unresolved
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const utils_1 = require("~/utils/utils");
const catalogUtils_1 = require("~/utils/catalogUtils");
const types_1 = require("../loading/types");
const actionCreators = __importStar(require("./actions"));
const types_2 = require("../types");
const initialState = {
    isLoading: types_1.LOADING_STATE.LOADING,
    isIncludedCompatibleFastenerLoading: types_1.LOADING_STATE.COMPLETE,
    includedFastenersMountTo: new Map(),
    extrusionsByExtrusionProfileType: {},
    panelReplacementMap: {},
    tSlotCoverReplacementMap: {},
};
const prepareItemReplacementMaps = (catalogItems) => {
    const extrusionsByExtrusionProfileType = {};
    const panelReplacementMap = {};
    const tSlotCoverReplacementMap = {};
    catalogItems.forEach((catalogItem) => {
        var _a, _b, _c;
        if ((_a = catalogItem.extrusionType) === null || _a === void 0 ? void 0 : _a.extrusionProfileType) {
            const { name: extrusionProfileTypeName } = catalogItem.extrusionType.extrusionProfileType;
            const extrusionsForExtrusionProfileType = extrusionsByExtrusionProfileType[extrusionProfileTypeName];
            if (extrusionsForExtrusionProfileType) {
                extrusionsForExtrusionProfileType.push(catalogItem);
            }
            else {
                extrusionsByExtrusionProfileType[extrusionProfileTypeName] = [catalogItem];
            }
        }
        else if (((_b = catalogItem.componentType) === null || _b === void 0 ? void 0 : _b.name) === types_2.COMPONENT_TYPE.PANEL) {
            const seriesLookupKey = (0, catalogUtils_1.generateReplacementMapSeriesKey)(catalogItem.series.map((s) => s.id));
            const thicknessPropertyValue = (0, utils_1.getItemProperty)(catalogItem, types_2.ITEM_PROPERTY_NAMES.THICKNESS);
            const thickness = (0, utils_1.isNumber)(thicknessPropertyValue !== null && thicknessPropertyValue !== void 0 ? thicknessPropertyValue : '') ? Number(thicknessPropertyValue) : 0;
            const thicknessLookupKey = (0, catalogUtils_1.generatePanelReplacementMapThicknessKey)(thickness);
            const panelReplacementMapForSeries = panelReplacementMap[seriesLookupKey];
            if (!panelReplacementMapForSeries) {
                panelReplacementMap[seriesLookupKey] = {};
            }
            const panelsWithRequiredThickness = panelReplacementMap[seriesLookupKey][thicknessLookupKey];
            if (!panelsWithRequiredThickness) {
                panelReplacementMap[seriesLookupKey][thicknessLookupKey] = [catalogItem];
            }
            else {
                panelsWithRequiredThickness.push(catalogItem);
            }
        }
        else if (((_c = catalogItem.componentType) === null || _c === void 0 ? void 0 : _c.name) === types_2.COMPONENT_TYPE.TSLOT_COVER) {
            const seriesLookupKey = (0, catalogUtils_1.generateReplacementMapSeriesKey)(catalogItem.series.map((s) => s.id));
            const tSlotCoverReplacementsForSeries = tSlotCoverReplacementMap[seriesLookupKey];
            if (tSlotCoverReplacementsForSeries) {
                tSlotCoverReplacementsForSeries.push(catalogItem);
            }
            else {
                tSlotCoverReplacementMap[seriesLookupKey] = [catalogItem];
            }
        }
    });
    return { extrusionsByExtrusionProfileType, panelReplacementMap, tSlotCoverReplacementMap };
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.requestCatalog): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestCatalogSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            window.data = action.payload;
            window.loadingTime = Date.now();
            const { extrusionsByExtrusionProfileType, panelReplacementMap, tSlotCoverReplacementMap } = prepareItemReplacementMaps(action.payload);
            draft.extrusionsByExtrusionProfileType = extrusionsByExtrusionProfileType;
            draft.panelReplacementMap = panelReplacementMap;
            draft.tSlotCoverReplacementMap = tSlotCoverReplacementMap;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestCatalogFail):
        case (0, typesafe_actions_1.getType)(actionCreators.requestCatalogMSFail): {
            draft.isLoading = types_1.LOADING_STATE.FAILED;
            // eslint-disable-next-line no-useless-return
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestCatalogMSSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            window.dataMS = action.payload;
            window.loadingTime = Date.now();
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestIncludedCompatibleFasteners): {
            draft.isIncludedCompatibleFastenerLoading = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestIncludedCompatibleFastenersSuccess): {
            draft.isIncludedCompatibleFastenerLoading = types_1.LOADING_STATE.COMPLETE;
            const newIncludedFastenersMountTo = new Map(draft.includedFastenersMountTo);
            newIncludedFastenersMountTo.set(action.payload.itemId, action.payload.mountToList);
            draft.includedFastenersMountTo = newIncludedFastenersMountTo;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestIncludedCompatibleFastenersFail): {
            draft.isIncludedCompatibleFastenerLoading = types_1.LOADING_STATE.FAILED;
            break;
        }
        default: {
            // eslint-disable-next-line no-useless-return
            return;
        }
    }
});
exports.default = reducer;
